import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { IAllRequirements } from "../../../models/AllRequirements";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { JVDropdown } from "../../../shared/JVDropdown";
import { Fetch } from "../../../shared/Fetch";
import { ILogin } from "../../../models/Login";
import { JVCheck } from "../../../shared/JVCheck";
import { JVCheckbox } from "../../../shared/JVCheckbox";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { Card } from "primereact/card";
import { Job_Type, Req_Term } from "../../../models/RequirementMast";

interface IProps {
    open: boolean,
    singleData: IAllRequirements,
    hideDialog: () => void,
    reload: boolean,
    setReload: (is: boolean) => void,
    toast: any,
}

interface IPublishTemp {
    skill?: boolean,
    branch?: boolean,
    company?: boolean,
    globally?: boolean,
}

interface IPublish {
    publish_Type: number,
}

const schema = yup.object({
    //publish_Type: yup.number().required("Publish Type Is Required"),
    skill: yup.boolean().nullable(),
    branch: yup.boolean().nullable(),
    company: yup.boolean().nullable(),
    globally: yup.boolean().nullable(),
});

const publishTable = (data: {
    branchId?: number,
    roleId?: number,
    publishBySkill?: boolean,
    publishInBranch?: boolean,
    publishInCompany?: boolean,
    publishGlobally?: boolean,
}) => {
    // const arr = [
    //     { name: "--SELECT--", value: 0 }
    // ];

    let arr = {
        skill: false,
        branch: false,
        company: false,
        globally: false,
    }

    if (data.publishBySkill === true) {
        arr = { ...arr, skill: true };
        // arr.push({ name: "Skill Wise", value: 1 });
    }
    if (data.publishInBranch === true) {
        arr = { ...arr, branch: true };
        // arr.push({ name: "In Branch", value: 2 });
    }
    if (data.publishInCompany === true) {
        arr = { ...arr, company: true };
        // arr.push({ name: "In Company", value: 3 });
    }
    if (data.publishGlobally === true) {
        arr = { ...arr, globally: true };
        // arr.push({ name: "Globally", value: 4 });
    }

    return arr;
}

export const PublishReq = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

    const { control, handleSubmit, watch, formState: { errors }, reset, setValue } = useForm<IPublishTemp>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const onHide = () => {
        setLoading(false);
        reset({ skill: false, branch: false, company: false, globally: false });
        props.hideDialog();
    }

    const saveToDB = async (params: { reqID: number, publishType: number }) => {
        const method = "PUT";
        const message = "Published Successfully";
        setLoading(true);
        const response = await Fetch("Requirement_MAST/publishReq", method, null, `reqID=${params.reqID}&publishType=${params.publishType}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            setLoading(false);
            props.setReload(!props.reload);
            onHide();
        } else setLoading(false);
    }

    const onSubmit = (data: IPublishTemp) => {
        if (data.skill !== true && data.branch !== true && data.company !== true && data.globally !== true) {
            props.toast.current.show({ severity: 'error', detail: "Select atleast 1 publish type", life: 3000 });
        } else {
            confirmDelete({
                publish_Type: data.skill === true ? 1 : (data.branch === true ? 2 : (data.company === true ? 3 : (data.globally === true ? 4 : 0))),
            });
        }

        // if (props.singleData.req_ID !== undefined && props.singleData.req_ID !== null && props.singleData.req_ID > 0) {
        //     const newData: { reqID: number, publishType: number } = {
        //         reqID: props.singleData.req_ID ?? 0,
        //         publishType: data.publish_Type
        //     }

        //     saveToDB(newData);
        // } else props.toast.current.show({ severity: 'error', detail: "Req ID not found", life: 3000 });
    }

    const dFooter = () => {
        return !(props.singleData.publish_Type !== undefined && props.singleData.publish_Type !== null && props.singleData.publish_Type > 0) ? (
            <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                <Button loading={loading} form="submissionForm1" label="PUBLISH" type="submit" style={{ width: '100px' }} ></Button>
                <Button className="p-button-outlined surface-200" style={{ width: '100px' }} label="CLEAR" onClick={() => { reset({ skill: false, branch: false, company: false, globally: false }); }} type="button"></Button>
            </div>
        ) : <></>;
    }

    const rejectFunc = () => {
        props.toast.current.show({ severity: "error", detail: "You have Canceled", life: 3000 })
    }

    const publishReq = async (data: IPublish) => {
        if (props.singleData.req_ID !== undefined && props.singleData.req_ID !== null && props.singleData.req_ID > 0) {
            const newData: { reqID: number, publishType: number } = {
                reqID: props.singleData.req_ID ?? 0,
                publishType: data.publish_Type
            }

            saveToDB(newData);
        } else props.toast.current.show({ severity: 'error', detail: "Req ID not found", life: 3000 });
    }

    const confirmDelete = (rowData: any) => {
        confirmDialog({
            message: `Are you sure you want to Publish This Requirement, Once Published Will not Revert.`,
            header: 'Confirm Publish',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => publishReq(rowData),
            reject: () => rejectFunc()
        });
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "skill") {
                if (value.skill === true) {
                    reset({
                        skill: true,
                        branch: false,
                        company: false,
                        globally: false,
                    });
                }
            }
            if (name === "branch") {
                if (value.branch === true) {
                    reset({
                        skill: false,
                        branch: true,
                        company: false,
                        globally: false,
                    });
                }
            }
            if (name === "company") {
                if (value.company === true) {
                    reset({
                        skill: false,
                        branch: false,
                        company: true,
                        globally: false,
                    });
                }
            }
            if (name === "globally") {
                if (value.globally === true) {
                    reset({
                        skill: false,
                        branch: false,
                        company: false,
                        globally: true,
                    });
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);
    const DateFormat = loginObj.date_Format;

    useEffect(() => {
        if (props.open && (props.singleData.publish_Type !== undefined && props.singleData.publish_Type !== null && props.singleData.publish_Type > 0)) {
            reset({ skill: (props.singleData.publish_Type === 1), branch: (props.singleData.publish_Type === 2), company: (props.singleData.publish_Type === 3), globally: (props.singleData.publish_Type === 4) });
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Publish Requirement" footer={dFooter} className="p-fluid" maximizable onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                size="small" stripedRows showGridlines responsiveLayout="scroll"
                value={[props.singleData || {}]} emptyMessage="No Requirements found."

            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="req_ID" header="Req.ID" />
                <Column field="user_Name" sortable header="Sales Manager" body={(rowData: any) => <span>{rowData?.user_Name?.split("-")[0]}</span>} />
                <Column field="salesCompany" header="Sales Comp(Branch)" />
                <Column field="req_Job_Title" header="Job Title" />
                <Column field="req_Duration" header="Duration" />
                <Column field="location" header="Location" />
                <Column field="req_Term" header="Job Term" body={(rowData: IAllRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
                <Column field="job_Type" header="Job Type" body={(rowData: IAllRequirements) => rowData.job_Type ? Job_Type[rowData.job_Type] : ""} />
                <Column field="req_CategoryName" header="Category" style={{ maxWidth: "8rem", overflow: "hidden" }} sortable />
                <Column field="req_Sub_CategoryName" header="Sub Category" style={{ maxWidth: "8rem", overflow: "hidden" }} sortable />
                <Column field="pDate" style={{ minWidth: '100px' }} header="Date" body={(rowData: any) => safeFormatDate(rowData.pDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="recruiter" header="Recruiter" />
                <Column field="hold" header="Status" body={(rowData: IAllRequirements) => rowData.hold ? "Hold" : "Unhold"} />
                <Column field="special_Constraint" header="Special Constraint" />

                <Column field="submission_id" header="Submittals" />
            </DataTable>
            <Card className=" mt-5">
                <form id="submissionForm1" onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVCheckbox column={4} disabled={(props.singleData.publish_Type !== undefined && props.singleData.publish_Type !== null && props.singleData.publish_Type > 0) || (publishTable(loginObj.publish_Roles || {}).skill === false)} label="Skill Wise" control={control} name="skill" />
                    <JVCheckbox column={4} disabled={(props.singleData.publish_Type !== undefined && props.singleData.publish_Type !== null && props.singleData.publish_Type > 0) || (publishTable(loginObj.publish_Roles || {}).branch === false)} label="In Branch" control={control} name="branch" />
                    <JVCheckbox column={4} disabled={(props.singleData.publish_Type !== undefined && props.singleData.publish_Type !== null && props.singleData.publish_Type > 0) || (publishTable(loginObj.publish_Roles || {}).company === false)} label="In Company" control={control} name="company" />
                    <JVCheckbox column={4} disabled={(props.singleData.publish_Type !== undefined && props.singleData.publish_Type !== null && props.singleData.publish_Type > 0) || (publishTable(loginObj.publish_Roles || {}).globally === false)} label="Globally" control={control} name="globally" />
                    {/* <JVDropdown column={4} label="Publish Type" control={control} disabled={(props.singleData.publish_Type !== undefined && props.singleData.publish_Type !== null && props.singleData.publish_Type > 0)} name="publish_Type" error={errors.publish_Type?.message} options={publishTable(loginObj.publish_Roles || {})} optionLabel="name" optionValue="value" placeholder="Select Publish Type" /> */}
                </form>
            </Card>
            <ConfirmDialog />
        </Dialog>
    );
}